import { render, staticRenderFns } from "./Upsert.vue?vue&type=template&id=72fb8e3c&scoped=true&"
import script from "./Upsert.vue?vue&type=script&lang=js&"
export * from "./Upsert.vue?vue&type=script&lang=js&"
import style0 from "./Upsert.vue?vue&type=style&index=0&id=72fb8e3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fb8e3c",
  null
  
)

export default component.exports